import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

// Components
import CustomField from "../../CustomField";

// Hooks
import useIncidentTypes from "../../../hooks/useIncidentTypes";

const IncidentTypeField = ({ setFieldValue, name, onChange, ...rest }) => {
  const [isDirty, setDirty] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const { isLoading, data } = useIncidentTypes();

  const options =
    !isLoading && data
      ? data.map(item => ({
          value: item.id,
          text: item.name
        }))
      : [];

  useEffect(() => {
    if (inputValue.length) {
      // no op
    } else if (setFieldValue && isDirty) {
      setFieldValue(name, "");
    }
  }, [inputValue, isDirty, name, setFieldValue]);

  const handleKeyUp = e => {
    setDirty(true);
    setInputValue(e.target.value);
  };

  const handleChange = (_, newValue) => {
    if (newValue) {
      if (onChange) onChange(newValue);
      setFieldValue(name, newValue);
    }
  };

  return (
    <>
      <CustomField
        {...rest}
        type="incidentType"
        name={name}
        options={options}
        loading={isLoading}
        getOptionSelected={(option, value) => option.value === value.value}
        getOptionLabel={option => option.name || option.text}
        onKeyUp={handleKeyUp}
        onChange={setFieldValue && handleChange}
      />
    </>
  );
};

IncidentTypeField.propTypes = {
  name: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func,
  onChange: PropTypes.func
};

IncidentTypeField.defaultProps = {
  onChange: null,
  setFieldValue: null
};

export default IncidentTypeField;
